var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.0694C8.09133 1.0694 8.18116 1.09295 8.26074 1.13776C8.32044 1.17137 8.37257 1.21637 8.41504 1.26959L8.4541 1.32526L14.9277 12.1339H14.9287C14.975 12.2141 14.9997 12.3049 15 12.3975C15.0003 12.4902 14.9765 12.5816 14.9307 12.6622C14.8847 12.7428 14.8182 12.8104 14.7383 12.8575C14.6584 12.9045 14.5673 12.9297 14.4746 12.9307H1.52539C1.43267 12.9297 1.34165 12.9045 1.26172 12.8575C1.18177 12.8104 1.11528 12.7428 1.06934 12.6622C1.02352 12.5816 0.999741 12.4902 1 12.3975C1.00023 12.3279 1.01444 12.2593 1.04102 12.1954L1.07129 12.1339L7.5459 1.32526C7.59325 1.24721 7.65971 1.18255 7.73926 1.13776C7.81884 1.09295 7.90867 1.0694 8 1.0694Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.0694L8.00199 7.5694",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00098 9.86768H8.00863",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorWarning);
export default __webpack_public_path__ + "static/media/error-warning.c3a51193386a63d607e394f9343ca414.svg";
export { ForwardRef as ReactComponent };